import Api from '../../../common/services/api';

export const NETWORK_UPDATE_NETWORK = 'network/UPDATE_NETWORK';

export default (values) => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  const { data: network } = await Api
    .put(`/v2/networks/${selected}`, values);

  dispatch({
    type: NETWORK_UPDATE_NETWORK,
    network,
  });
};
